export default __webpack_public_path__ + "static/media/featBgMb.689e2231.png";